import 'portal-base/src/components/ki-portal-base-toast/ki-portal-base-toast';

window.messageMapping = window.messageMapping || {};

function handleShowToast({ detail }) {
    const { content, title, type, size } = detail;
    const existingToast = window.messageMapping[content];
    if (existingToast && existingToast.isConnected) {
        existingToast.setAttribute('count', Number(existingToast.getAttribute('count')) + 1);
    } else {
        const stack = document.querySelector('.toast-stack');
        if (!stack) return;
        const toast = document.createElement('ki-portal-base-toast');
        window.messageMapping[content] = toast;
        toast.type = type;
        toast.title = title;
        toast.content = content;
        toast.size = size;
        stack.appendChild(toast);
        setTimeout(() => toast.open(), 0);
    }
}

export function initToastService() {
    window.addEventListener('showToast', handleShowToast);
}

export function showToast({ content, title, type = 'info', size }) {
    window.dispatchEvent(new CustomEvent('showToast', { detail: { content, title, type, size } }));
}
